import { HttpService } from '@services/http.service';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { EndpointParams } from '@models/utils/endpoint-params';

@Injectable({
    providedIn: 'root'
})
export class BusinessService extends HttpService {
    private readonly defaultEndpointParams: EndpointParams = { app: 'center', version: 1 };

    searchInfo(publicToken: string): Observable<any> {
        return this.get('public/businesscentral', this.defaultEndpointParams, { centerToken: publicToken });
    }
}
